import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { FiCopy, FiExternalLink, FiEye, FiEyeOff } from "react-icons/fi";
import { getOdooAccount } from "../../redux/actions/CompanyActions";

// Credentials of the company's Gestion 360 ERP account
function ErpAccessCard() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authUser);
  const { activeCompany } = useSelector((state) => state.companies);
  const [account, setAccount] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (!user?.token || !activeCompany?._id) return;

    dispatch(
      getOdooAccount(user.token, activeCompany._id, (data) =>
        setAccount(data || null),
      ),
    );
  }, [user?.token, activeCompany?._id, dispatch]);

  const copyPassword = () => {
    navigator.clipboard.writeText(account?.password || "");
    Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 2500,
    }).fire({ icon: "success", title: "Mot de passe copié" });
  };

  return (
    <section className="dash-card dash-erp">
      <div>
        <h2 className="dash-card-title">Accès à votre ERP</h2>
        {account?.email ? (
          <dl className="dash-details">
            <dt>Adresse</dt>
            <dd>{account.url || "Bientôt communiquée par nos équipes"}</dd>
            <dt>Identifiant</dt>
            <dd>{account.email}</dd>
            {account.password && (
              <>
                <dt>Mot de passe</dt>
                <dd className="dash-secret">
                  <span>{showPassword ? account.password : "••••••••"}</span>
                  <button
                    type="button"
                    className="dash-icon-button"
                    onClick={() => setShowPassword((shown) => !shown)}
                    aria-label={
                      showPassword
                        ? "Masquer le mot de passe"
                        : "Afficher le mot de passe"
                    }
                  >
                    {showPassword ? <FiEyeOff /> : <FiEye />}
                  </button>
                  <button
                    type="button"
                    className="dash-icon-button"
                    onClick={copyPassword}
                    aria-label="Copier le mot de passe"
                  >
                    <FiCopy />
                  </button>
                </dd>
              </>
            )}
          </dl>
        ) : (
          <p className="dash-page-lead">
            Vos identifiants apparaîtront ici dès que votre ERP sera configuré
            par nos équipes.
          </p>
        )}
      </div>
      {/* Each company has its own space, entered by the operator */}
      {account?.url && (
        <a
          className="dash-button"
          href={account.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          Ouvrir l'ERP <FiExternalLink aria-hidden="true" />
        </a>
      )}
    </section>
  );
}

export default ErpAccessCard;
